import React from "react";
import { Routes, Route } from "react-router-dom";
import About from "../pages/About";
import Homepage from "../pages/HomePage";
import Sidebar from "./Sidebar";
import Work from "../pages/Work";
import Meplug from "../pages/projects/Meplug";
import Education from "../pages/Education";
import Skill from "../pages/Skill";
import MenuToggle from "./MenuToggle";

export default function AppRoutes() {
  return (
    <>
      <MenuToggle/>
      <Sidebar />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<About />} />
        <Route path="/work" element={<Work />} />
        <Route path="/education" element={<Education/> } />
        <Route path="/skill" element={<Skill/> } />
        <Route path="projects/*" element={<ProjectRoutes />} />
      </Routes>
    </>
  );
}

function ProjectRoutes() {
  return (
    <Routes>
      <Route path="/meplug" element={<Meplug />} />
    </Routes>
  );
}
